import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={14}
    height={17}
    viewBox="0 0 14 17"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="M3.83.6h-1.9C1.3.6.73 1.11.73 1.8v13.87c0 .63.51 1.2 1.2 1.2h1.9c.63 0 1.2-.51 1.2-1.2V1.8c0-.7-.57-1.21-1.2-1.21V.6ZM11.93.6h-1.9c-.63 0-1.2.51-1.2 1.2v13.87c0 .63.51 1.2 1.2 1.2h1.9c.63 0 1.2-.51 1.2-1.2V1.8c0-.7-.57-1.21-1.2-1.21V.6Z"
    />
  </Svg>
);
export default SvgComponent;
